import { Brick } from './Brick'

export abstract class WebBrick extends Brick {
    get sortIndex(): number {
        return 0
    }

    get license(): string | null { return null }   
}
